import FuzzySearch from 'fuzzy-search'
import { getRoot, types } from 'mobx-state-tree'

import { bookingExperiencePriority } from '../utils/helpers'

export const ProviderStore = types.model('ProviderStore').views(self => ({
  get root() {
    return getRoot(self)
  },
  get searchStore() {
    return self.root.searchStore
  },
  get providers() {
    return Array.from(self.root.providers.values()).sort((a, b) => {
      if (a.rank > b.rank) {
        return 1
      }
      if (a.rank < b.rank) {
        return -1
      }
      return 0
    })
  },
  get filteredProviders() {
    const hasTrackedSearchIds =
      self.searchStore.searchResultLocationIds.length > 0
    const searchResultLocations =
      self.root.locationStore.activeSearchResultLocations
    const searchResultLocationIds = new Set(
      hasTrackedSearchIds
        ? self.searchStore.searchResultLocationIds
        : searchResultLocations.map(location => location.id)
    )
    const searchResultProviderIds = new Set()
    const bookingPriorityByProviderId = new Map()

    searchResultLocations.forEach(location => {
      ;(location.providers || []).forEach(provider => {
        if (provider?.id) {
          searchResultProviderIds.add(provider.id)
          const currentPriority = bookingPriorityByProviderId.get(provider.id)
          const locationPriority = bookingExperiencePriority(
            location.bookingExperience
          )
          if (
            currentPriority === undefined ||
            locationPriority < currentPriority
          ) {
            bookingPriorityByProviderId.set(provider.id, locationPriority)
          }
        }
      })
    })

    let result = self.providers.filter(provider => {
      if (provider.locations?.length && hasTrackedSearchIds) {
        return provider.locations.some(
          location => location && searchResultLocationIds.has(location.id)
        )
      }

      return searchResultProviderIds.has(provider.id)
    })

    if (self.searchStore.acceptsOnlineBookingFilterActive) {
      result = result.sort((a, b) => {
        if (a.rank !== b.rank) {
          return a.rank - b.rank
        }
        const aBookingPriority = bookingPriorityByProviderId.get(a.id) ?? 2
        const bBookingPriority = bookingPriorityByProviderId.get(b.id) ?? 2

        return aBookingPriority - bBookingPriority
      })
    }

    // Apply name filter if provided
    if (self.searchStore.providerName) {
      const searcher = new FuzzySearch(result, ['name'], {
        caseSensitive: false,
        sort: true,
      })
      result = searcher.search(self.searchStore.providerName)
    }

    // Apply specialty filter if provided
    if (self.searchStore.filteredSpecialty) {
      result = result.filter(provider =>
        provider.specialties?.some(
          specialty => specialty.name === self.searchStore.filteredSpecialty
        )
      )
    }

    return result
  },
}))
